module.exports = __webpack_public_path__ + "img/woman-rings.ccb10982.jpg";